// Module
var code = " <span class=\"tiny-badge\" ng-class=\"ctrl.badgeClass\">{{'STUDENT_APPLICATIONS.STATE.' + ctrl.state | translate}}</span> ";
// Exports
module.exports = code;